import React, { useEffect } from 'react';
import styled from 'styled-components';

import { commonEvents } from '../../../constants/event';
import { dimensionTypes } from '../../../constants/retention';
import RetentionDimensionSelect from '../RetentionDimensionSelect';
import RetentionExecutionOptionsBar from '../../../containers/retention/simple/RetentionExecutionOptionsBar';
import DocsLink from '../../docs/DocsLink';
import docsBookmarks from '../../../constants/docs';

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  outline: 1px solid #ccc;
  padding: 20px;
  margin-bottom: 24px;
`;

const dtToReturnEventMappings = {
  [dimensionTypes.DAILY]: commonEvents.DAU,
  [dimensionTypes.WEEKLY]: commonEvents.WAU,
  [dimensionTypes.MONTHLY]: commonEvents.MAU,
};

const onDimensionTypeChangeCompose = (dt, onReturnEventChange, onDimensionTypeChange) => {
  onReturnEventChange(dtToReturnEventMappings[dt]);
  onDimensionTypeChange(dt);
};

const RetentionSimplifiedComposeContainer = ({
  selectedDimensionType,
  onReturnEventChange,
  onFirstEventChange,
  onDimensionTypeChange,
}) => {
  const dimensionType = selectedDimensionType || dimensionTypes.DAILY;

  useEffect(() => {
    onFirstEventChange(commonEvents.REGISTER_FIRST_START);
    onReturnEventChange(dtToReturnEventMappings[dimensionType]);
    onDimensionTypeChange(dimensionType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledDiv>
      <div>
        <RetentionDimensionSelect
          dimensionType={dimensionType}
          onDimensionTypeChange={(dt) =>
            onDimensionTypeChangeCompose(dt, onReturnEventChange, onDimensionTypeChange)
          }
        />
        {(dimensionType === dimensionTypes.WEEKLY || dimensionType === dimensionTypes.MONTHLY) && (
          <DocsLink
            scrolTo={docsBookmarks.retentionTimeRange}
            styleIcon={{ fontSize: 20, marginLeft: 5, color: 'gray' }}
          />
        )}
      </div>
      <RetentionExecutionOptionsBar />
    </StyledDiv>
  );
};

export default RetentionSimplifiedComposeContainer;
